import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { UserContext } from '../../contexts/UserContext'
import { ToastContainer, toast } from 'react-toastify'
import axios from 'axios'
//import styles
import style from './a.module.css'
import "react-toastify/ReactToastify.min.css";
//import components
import BackButton from '../../components/BackButton/BackButton'
import TextBox from '../../components/TextBox/TextBox'
import PrimaryButton from '../../components/PrimaryButton/PrimaryButton'
import { baseUrl } from '../../App'
//import assets
import emailIcon from '../../assets/icons/material-symbols_mail.svg'
import passwordIcon from '../../assets/icons/mdi_password.svg'

const SignIn = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const { user, setUser, saveUser } = useContext(UserContext)

  useEffect(() => {
    if (user) {
      navigate('/profile')
    }
  }, [])

  const handleSignIn = async (e) => {
    e.preventDefault()
    try {
      if (localStorage.getItem('user')) {
        toast.info('Already Signed In 🥳', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        navigate('/profile')
        return
      }


      const data = await axios.post(baseUrl + '/users/login', {
        email,
        password
      })

      saveUser(data, setUser)

      toast.success('Signed In 🥳', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      })

      navigate('/profile')

    } catch (error) {
      toast.error(error.response.data.error)
    }
  }

  return (
    <div className={style.main}>
      <div className='AppNavbarGap'></div>
      <div className={style.btnCont} onClick={() => navigate(-1)}>
        <BackButton />
      </div>
      <h1 className={style.title}>Sign in to your account</h1>
      <div className={style.signinForm}>
        <TextBox type="email" placeholder="Email" icon={emailIcon} value={email} onChange={(e) => setEmail(e.target.value)} inputBox={true}/>
        <TextBox type="password" placeholder="Password" icon={passwordIcon} value={password} onChange={(e) => setPassword(e.target.value)} inputBox={true}/>
      </div>
      <div className={style.formFooter}>
        <div className={style.forgotPass} onClick={() => navigate('/forgetpassword')}><span>Forgot Password ?</span></div>
        <div className={style.signInBtn} onClick={handleSignIn}><PrimaryButton title="Sign In" /></div>
        <h2 className={style.registerTransfer} onClick={() => navigate('/signup')}>Don’t have account? <span className={style.register}>Register here</span></h2>
      </div>
    </div>
  )
}

export default SignIn
